var React = require('react');

function Info (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"}));
}

Info.defaultProps = {"width":"13px","height":"21px","viewBox":"0 0 192 512"};

module.exports = Info;

Info.default = Info;
